export default "__VITE_ASSET__F7WKEQ3k__"